import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "d-none" }, [
    _c(
      "div",
      { staticClass: "lpu-schedule" },
      [
        _vm.isVisibleSkeleton
          ? _c("LpuScheduleSkeleton")
          : [
              _c(
                "div",
                { staticClass: "lpu-schedule__days" },
                _vm._l(_vm.schedule.schedule_days, function (time, day) {
                  return _c(
                    "div",
                    {
                      key: day,
                      staticClass: "lpu-schedule__day d-flex",
                      class: {
                        "text-subtitle-1 lpu-schedule__day--current":
                          day === _vm.schedule.now_weekday_translit,
                        "text-body-1":
                          day !== _vm.schedule.now_weekday_translit,
                      },
                    },
                    [
                      _c("div", { staticClass: "lpu-schedule__date" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(_vm.schedule.full_days[day], _vm.options)
                            ) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t(time, _vm.options)) +
                          "\n        "
                      ),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm.schedule.lpu_exceptions.length
                ? _c(VDivider, {
                    staticClass: "lpu-schedule__divider",
                    attrs: { vertical: "" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.schedule.lpu_exceptions.length
                ? _c(
                    "div",
                    { staticClass: "lpu-schedule__days" },
                    [
                      _c("div", { staticClass: "text-subtitle-1 text--text" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("График работы в праздники", _vm.options)
                            ) +
                            "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(
                        _vm.schedule.lpu_exceptions,
                        function (exception, index) {
                          return _c(
                            "div",
                            {
                              key: `holiday-${index}`,
                              staticClass: "lpu-schedule__day text-body-1",
                            },
                            [
                              _c("div", { staticClass: "lpu-schedule__date" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(exception.date, _vm.options)
                                    ) +
                                    "\n          "
                                ),
                              ]),
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t(exception.time, _vm.options)) +
                                  "\n        "
                              ),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  )
                : _vm._e(),
            ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }